import AuditLogGroup from './AuditLogGroup';

export default AuditLogGroup;
